import { Controller } from '@hotwired/stimulus';
import markerSVG from '../../images/icons/marker.svg';
import { getMeta } from '../helpers';

export default class extends Controller {

    markers = [];

    connect() {

        let locations = this.element.dataset.locations;
        locations = locations ? JSON.parse(locations) : {};
        if (locations.length < 1) {
            return;
        }

        Promise.all([
            import('leaflet'),
            import('protomaps-leaflet'),
            import('leaflet-gesture-handling'),
        ]).then(([L, protomapsL, GestureHandling]) => {
            this.element.removeAttribute('data-locations');

            const map = L.map(this.element, {
                center: [locations[0]['lat'], locations[0]['lng']],
                zoom: 15,
                zoomSnap: false,
                scrollWheelZoom: false,
                gestureHandling: true,
            });

            protomapsL.leafletLayer({
                attribution: '',
                maxZoom: 16,
                url: 'https://api.protomaps.com/tiles/v4/{z}/{x}/{y}.mvt?key=35b1a5c7ab2cb293',
                flavor: 'white',
                lang: 'lt'
            }).addTo(map);

            const markerIcon = L.icon({
                iconUrl: markerSVG,
                iconSize: [50, 60],
                iconAnchor: [25, 60],
                popupAnchor: [0, 0],
            });

            locations.forEach((data) => {
                const marker = L.marker([data['lat'], data['lng']], { icon: markerIcon });
                marker.addTo(map);
                this.markers.push(marker);
            });

            if (locations.length > 1) {
                const bounds = new L.featureGroup(this.markers).getBounds();
                map.fitBounds(bounds, { padding: [50, 100] });

                window.addEventListener('resize', () => {
                    setTimeout(() => {
                        const bounds = new L.featureGroup(this.markers).getBounds();
                        map.fitBounds(bounds, { padding: [50, 100] });
                    }, 10);
                });
            }

            const resourcePath = getMeta('theme-url');
            if ('serviceWorker' in navigator) {
                navigator.serviceWorker.register(resourcePath + 'map-worker.js').catch(console.error);
            }
        });
    }
}